import axios from 'axios';
import { URL } from '../url/api';
import { getSessionToken } from '../utils/auth';
import { safeLocalStorage } from '../utils/safeStorage';

const api = axios.create({
  baseURL: URL,
});

api.interceptors.request.use((config) => {
  // A throw here would reject every outgoing request app-wide, so storage
  // access failures (blocked/full storage) must never escape this callback
  // — the request should still go out with whatever token getSessionToken
  // could recover (including its in-memory fallback).
  try {
    const token = getSessionToken();
    if (token) {
      safeLocalStorage.setItem("user_session", token);
      config.headers.Authorization = `Bearer ${token.replace(/"/g, '')}`;
    }
  } catch (e) {}
  return config;
});

export default api;
